'use strict';

var Consts = require('consts');
var i18n = require('utils/i18n');
var Strings = require('utils/strings');

var HandlingUtils = {};

HandlingUtils.modeConfigs = {};
HandlingUtils.timeConst = {};

HandlingUtils.initializeConstants = function () {
    this.modeConfigs = {
        auto: {
            icon: 'fa fa-clock-o',
            color: 'auto',
            text: i18n.TR('Auto'),
        },
        day: {
            icon: 'wi wi-day-sunny',
            color: 'day',
            text: i18n.TR('Tag'),
        },
        dayDisabled: {
            icon: 'fa fa-power-off',
            color: 'standby',
            text: i18n.TR('Tag'),
        },
        night: {
            icon: 'fa fa-moon-o',
            color: 'night',
            text: i18n.TR('Nacht'),
        },
        nightDisabled: {
            icon: 'fa fa-power-off',
            color: 'standby',
            text: i18n.TR('Nacht'),
        },
        standby: {
            icon: 'fa fa-power-off',
            color: 'standby',
            text: i18n.TR('Standby'),
        },
        antiFrost: {
            icon: 'wi wi-snowflake-cold',
            color: 'antifreeze',
            text: i18n.TR('Frostschutz'),
        },
        holiday: {
            icon: 'fa fa-plane',
            color: 'custom',
            text: i18n.TR('Urlaub'),
        },
    };
    this.timeConst = {
        week: i18n.TR('Mo') + ' - ' + i18n.TR('So'),
        workweek: i18n.TR('Mo') + ' - ' + i18n.TR('Fr'),
        weekend: i18n.TR('Sa') + ' - ' + i18n.TR('So'),
        monday: i18n.TR('Montag'),
        tuesday: i18n.TR('Dienstag'),
        wednesday: i18n.TR('Mittwoch'),
        thursday: i18n.TR('Donnerstag'),
        friday: i18n.TR('Freitag'),
        saturday: i18n.TR('Samstag'),
        sunday: i18n.TR('Sonntag'),
    };
};

HandlingUtils.simpleDisplayMode = function (chosen, active) {
    switch (active) {
        case 'standby': {
            if (chosen == 'day') {
                return 'dayDisabled';
            }
            if (chosen == 'night') {
                return 'nightDisabled';
            }
            return 'standby';
        }
        case 'day': {
            if (chosen == 'night' || chosen == 'standby') {
                return 'antiFrost';
            }
            return 'day';
        }
        case 'night': {
            if (chosen == 'day') {
                return 'dayDisabled';
            }
            if (chosen == 'standby') {
                return 'antiFrost';
            }
            return 'night';
        }
    }
    return 'auto';
};

// shifts the current time by the given offset
HandlingUtils.getDate = function (offsetInMinutes) {
    // roundMinutes rounds any number to multiples of 15. Examples:
    // 17     -> 15
    // 23     -> 30
    // 70.123 -> 75. . .
    function roundMinutes(min) {
        return min - (min % 15) + Math.round((min % 15) / 15) * 15;
    }

    // get the current date
    var activationDate = new Date();
    activationDate.setMinutes(roundMinutes(activationDate.getMinutes() + offsetInMinutes));
    var hours = Strings.twoDigitsLeadingZero(activationDate.getHours());
    var min = Strings.twoDigitsLeadingZero(activationDate.getMinutes());
    var date = activationDate.toLocaleDateString();

    return { date: date, hours: hours, minutes: min };
};

// Routine die Zeitrohdaten in SVG-Koordinaten umwandelt. Erwartet ein Array mit genau 96 Einträgen
// und den Werten 0 oder 1. Eine zusammenhängende Folge von 1en steht für ein Intervall.
// Gibt ein array mit denjenigen Punkten zurück, an dem ein Wechsel zwischen 0 und 1 stattfindet,
// sowie ein string-Array mit den Uhrzeiten
HandlingUtils.convertTimeData = function (timeData) {
    var intervalEndings = [0];
    var timeStrings = [];
    var currentTime = 0;
    var oldTime = 0;
    var currentValue = timeData[0];
    var oldValue = timeData[0];

    for (var i = 0; i < 96; i++) {
        currentValue = timeData[i];
        if (currentValue !== oldValue) {
            intervalEndings.push(i);

            // did a full intervall end?
            if (oldValue === 1) {
                timeStrings.push(this.minutesToString(oldTime) + ' - ' + this.minutesToString(currentTime));
            }
            oldTime = currentTime;
        }
        currentTime += 15;
        oldValue = currentValue;
    }

    // at the last point no change occures, so we add it manually
    intervalEndings.push(96);
    if (timeData[95] === 1) {
        timeStrings.push(this.minutesToString(oldTime) + ' - ' + this.minutesToString(currentTime));
    }
    return [intervalEndings, timeStrings];
};

HandlingUtils.minutesToString = function (minutes) {
    var hours = Strings.twoDigitsLeadingZero(Math.floor(minutes / 60));
    var min = Strings.twoDigitsLeadingZero(minutes % 60);
    return hours + ':' + min;
};

HandlingUtils.initializeDatePicker = function (ui, timer, drops, cb) {
    ui.daterangepicker(
        {
            locale: {
                format: 'DD.MM.YYYY HH:mm',
                applyLabel: i18n.TR('Setzen'),
                cancelLabel: i18n.TR('Abbrechen'),
                daysOfWeek: Consts.DaysOfWeek,
                monthNames: Consts.MonthNames,
                firstDay: 1,
            },
            singleDatePicker: true,
            timePicker: true,
            timePicker24Hour: true,
            startDate: timer,
            endDate: timer,
            minDate: moment(),
            maxDate: moment().add(65535, 'minutes'),
            opens: 'center',
            drops: drops,
            buttonClasses: ['btn', 'btn-sm'],
            applyClass: 'btn-default',
            cancelClass: 'btn-white',
        },
        cb
    );
};

// returns the sign of a number. Is present, since IE11 and below don't support Math.sign() >(
HandlingUtils.sign = function (number) {
    return parseFloat(number) >= 0 ? 1 : -1;
};

module.exports = HandlingUtils;
